export default {"src":"/_next/static/media/xpm.7e6ab840.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};